// extracted by mini-css-extract-plugin
module.exports = {"main":"LogoLoad_main__2Rexc","image":"LogoLoad_image__3CFOU"};